import { assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestGenerationAdjustingAdd extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GENERATION_DURATION_ADJUSTING_ADD;

  /*
   * FIELDS
   */
  user_task_id!: string;
  generation_id!: string;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    assert_string_object_id(this.user_task_id);
    assert_string_object_id(this.generation_id);
  }
}
